import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { url } from "@/utils";

export default function NavItem({
  path,
  name,
}: {
  readonly path: string;
  readonly name: string;
}) {
  return (
    <div className="transform hover:scale-x-110 transition-transform text-base">
      <NavLink
        className={({ isActive }) =>
          isActive
            ? " text-orange-50 font-bold flex items-center"
            : "flex items-center hover:text-orange-50 hover:font-bold text-secondary"
        }
        to={path}
      >
        {name}
      </NavLink>
    </div>
  );
}
